import WalletWithCashImage from "@assets/images/wallet-with-cash.png";
import { SpinerPage } from "@components/loaders/spiner";
import { FinanceService } from "@services/finance.service";
import { SchoolService } from "@services/school.service";
import { useThemeStore } from "@stores/theme.store";
import { useQuery } from "@tanstack/react-query";
import { toRp } from "@utils/helper";
import { linkPage } from "@utils/router";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const BillPage = () => {
  const navigate = useNavigate();
  const { setFooter, setHeader, setAppBar } = useThemeStore((state) => state);

  const { data: dataNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });
  const nis = dataNis?.data?.nis ?? "";

  const { data, isPending } = useQuery({
    queryKey: [FinanceService.queries.GET_TAGIHAN, nis],
    queryFn: () => FinanceService.daftarTagihan({ nis }),
  });

  useEffect(() => {
    setFooter(false);
    setHeader({
      type: "small",
      title: "Daftar Tagihan",
      buttonBack: true,
      avatar: true,
    });
    setAppBar({ leading: "back", title: "Daftar Tagihan" });
  }, [setFooter, setHeader, setAppBar]);

  return (
    <>
      <SpinerPage show={isPending} />
      <div className="tw-mx-4 tw-grid tw-grid-cols-2">
        {data?.data?.map((item, idx) => (
          <div
            key={idx}
            className="card card-style"
            onClick={() =>
              item.typeBill === "bulanan"
                ? navigate(linkPage.FINANCE_BILL_MONTHLY)
                : navigate(linkPage.FINANCE_ONE_BILL)
            }
          >
            <div className="content p-1 color-theme">
              <img
                src={WalletWithCashImage}
                alt="wallet-with-cash"
                className="tw-w-1/3"
              />
              <div className="tw-mt-4 tw-font-medium tw-text-base text-uppercase">
                {item.typeBill}
              </div>
              <small>Total</small>
              <div className="m-0">{toRp(item.nominal)}</div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
